const BASE_TYPES = ['Integer', 'Decimal', 'Boolean', 'String', 'Date', 'DateTime', 'Enum', 'Collection'];
export const Types = {
    Integer: { base: 'Integer' },
    Decimal: { base: 'Decimal' },
    Boolean: { base: 'Boolean' },
    String: { base: 'String' },
    Date: { base: 'Date' },
    DateTime: { base: 'DateTime' },
    Collection: { base: 'Collection' },
};
export function isCollection(type) {
    return type?.base === 'Collection';
}
export function isNumeric(type) {
    return type.base === 'Integer' || type.base === 'Decimal';
}
export function isTemporal(type) {
    return type.base === 'Date' || type.base === 'DateTime';
}
/** Two types that are the same for comparison and assignment: equal bases, and for enums the same enum. */
export function sameType(a, b) {
    return a.base === b.base && (a.base !== 'Enum' || a.enumName === b.enumName);
}
export function describeType(type) {
    return type.base === 'Enum' ? `Enum<${type.enumName}>` : type.base;
}
/** Parses a base type name as a host declares it (`Decimal`, `Enum` with enumName). */
export function parseType(name, enumName, enumCodes) {
    if (!BASE_TYPES.includes(name))
        return undefined;
    const base = name;
    return base === 'Enum' ? { base, enumName, enumCodes } : { base };
}
const EMPTY_SCOPE = { resolve: () => undefined };
/** The scope an aggregate's body is resolved and checked in: the collection's members, or nothing when it declares none. */
export function scopeOf(collection) {
    return collection.members ?? EMPTY_SCOPE;
}
export function resultType(type, valueType, nullable, scale, unit = null, currency = null) {
    return { type, valueType, nullable, scale, unit, currency };
}
export function isNumericResult(result) {
    return result.type !== null && isNumeric(result.type);
}
export function describeResult(result) {
    return result.type ? describeType(result.type) : 'null';
}
/** The unit for a quantity, the currency for an amount or rate; what FL-E11 compares. */
export function measureOf(result) {
    switch (result.valueType) {
        case 'Quantity':
            return result.unit;
        case 'Amount':
        case 'Rate':
            return result.currency;
        default:
            return null;
    }
}
